/*
  Bloc d'achat q4 (section q4-main-product) : modèle (Premium ou Standard), packs, quantité, prix (et prix
  barré s'il est renseigné dans Shopify), date de livraison estimée, barre fixe, galerie (vignettes, zoom),
  et choix demandés par l'URL
  (?modele=2, ?pack=2, ?quantite=2 : choix faits par le visiteur ou un lien, jamais imposés par défaut).
  Offre « 2 bâches » (v10, prix par modèle en v11) : la quantité envoyée suit le choix 1 / 2 bâches ; les prix
  affichés suivent les réductions automatiques Shopify « Pack 2 bâches Premium / Standard ».
  Offre de lancement (v14) : mention sous le prix pour le seul modèle concerné, masquée à partir de la date du
  nouveau prix ; galerie collante sous l'en-tête, ou par le bas si elle est plus haute que la fenêtre.
  Barre fixe (v15) : elle s'efface quand le bandeau d'appel de fin de page ou le pied de page est à l'écran,
  pour ne pas recouvrir leur bouton.
  Date de livraison (v16) : jours fériés français exclus, recalculée quand la page revient à l'écran. Barre fixe (v16) :
  elle n'apparaît qu'une fois le bouton principal dépassé.
  v17d : flèches sur la photo et sur la bande de vignettes (quatre visibles) ; frise « Commandé, Expédié, Livré »
  remplie avec la date du jour et l'intervalle de livraison estimé.
  v17e : économie en euros de la carte 2 + 1 (modèle choisi) ; carrousel d'avis (défilement au doigt, points de
  pagination) ; dates des avis en clair (« hier », « il y a 2 semaines », puis la date).
  Chargé en « defer » par la section ; chaque bloc d'achat de la page est initialisé une seule fois,
  y compris après un rechargement de section dans l'éditeur de thème (événement shopify:section:load).
*/
(() => {
  const euros = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  const initialiser = (racine) => {
    if (racine.dataset.q4Pret) return;
    racine.dataset.q4Pret = '1';

    const offres = [...racine.querySelectorAll('.q4-form .q4-offre__radio')];
    const blocOffres = racine.querySelector('.q4-form .q4-offres');
    const prixBouton = racine.querySelectorAll('[data-q4-prix]');
    const prixPrincipal = racine.querySelector('[data-q4-prix-principal]');
    const barrePrincipal = racine.querySelector('[data-q4-barre-principal]');
    const reference = racine.querySelector('[data-q4-reference]');
    const nomBarre = racine.querySelector('[data-q4-offre-nom]');
    const pleinBarreFixe = racine.querySelector('[data-q4-barre-fixe-plein]');
    // Offre de lancement (v14) : finie le jour du nouveau prix, minuit heure du visiteur (page servie depuis un cache)
    const lancement = racine.querySelector('[data-q4-lancement]');
    const lancementFini = lancement ? Date.now() >= new Date(lancement.dataset.fin + 'T00:00:00').getTime() : true;
    racine.querySelectorAll('[data-q4-lancement-tuile]').forEach((ligne) => {
      ligne.hidden = lancementFini;
    });
    const champQuantite = racine.querySelector('[data-q4-quantite-champ]');
    // Offre « 2 bâches » (v11) : prix du lot de 2 propre à chaque modèle (data-duo-1, data-duo-2), calculé comme
    // les réductions automatiques Shopify « Pack 2 bâches » : chaque paire du même modèle au prix du lot, la
    // bâche restante au prix unitaire (3 Premium = 54,95 € + 34,95 €).
    const offreQuantite = racine.querySelector('[data-q4-quantites]');
    const remiseAffichee = racine.querySelector('[data-q4-remise-qte]');
    // Pourcentage affiché « 21 % de réduction » : écart au prix plein, arrondi à l'unité (même calcul que la section)
    const pourcentDe = (plein, reduit) => Math.round(((plein - reduit) / plein) * 100) + '\u00a0% de réduction';
    // v17b : « 2 bâches achetées = la 3e offerte » (data-q4-trois), réduction Shopify non cumulable : une bâche sur
    // trois offerte. Shopify retient la meilleure des réductions (3 Premium = 69,90 €, 4 = 104,85 €, vérifié au calcul).
    const troisActif = Boolean(offreQuantite && offreQuantite.hasAttribute('data-q4-trois'));
    const totalPour = (centimes, nombre, duo) => {
      const parPaires =
        offreQuantite && duo > 0 && duo < centimes * 2
          ? Math.floor(nombre / 2) * duo + (nombre % 2) * centimes
          : centimes * nombre;
      const parTrois = troisActif ? (nombre - Math.floor(nombre / 3)) * centimes : parPaires;
      return Math.min(parPaires, parTrois);
    };
    const parametres = new URLSearchParams(window.location.search);
    let taille = '1';

    // Valeur d'une offre pour le modèle choisi.
    // getAttribute plutôt que dataset : « data-id-1 » ne devient pas « dataset.id1 ».
    const lire = (radio, cle) => radio.getAttribute('data-' + cle + '-' + taille) || '';

    const quantite = () => {
      const n = parseInt(champQuantite ? champQuantite.value : '1', 10);
      return Number.isFinite(n) && n > 0 ? Math.min(n, 10) : 1;
    };

    const mettreAJourPrix = () => {
      const choisie = offres.find((radio) => radio.checked);
      if (!choisie) return;
      const centimes = parseInt(lire(choisie, 'cents'), 10);
      const nombre = quantite();
      const duo = parseInt(lire(choisie, 'duo'), 10) || 0;
      const total = Number.isFinite(centimes) ? totalPour(centimes, nombre, duo) : NaN;
      const texte = Number.isFinite(total) ? euros.format(total / 100) : lire(choisie, 'prix');
      prixBouton.forEach((element) => {
        element.textContent = texte;
      });
      if (prixPrincipal) prixPrincipal.textContent = texte;
      // Prix barré (format Nike : prix, prix barré gris, pourcentage vert), deux références jamais cumulées :
      // le lot (les bâches au prix unitaire actuel), sinon une vraie réduction saisie dans Shopify
      // (« Prix avant réduction » : le prix le plus bas des 30 jours précédents, renseigné par le marchand)
      const centimesBarre = parseInt(lire(choisie, 'barre-cents'), 10) || 0;
      const prixUnitaires = Number.isFinite(centimes) ? centimes * nombre : 0;
      const lot = Number.isFinite(total) && total < prixUnitaires;
      let plein = 0;
      if (lot) plein = prixUnitaires;
      else if (Number.isFinite(centimes) && centimesBarre > centimes) plein = centimesBarre * nombre;
      const reduit = plein > 0 && Number.isFinite(total) && total < plein;
      if (barrePrincipal) barrePrincipal.hidden = true;
      if (reference) reference.hidden = !(reduit && !lot);
      if (remiseAffichee) {
        remiseAffichee.hidden = !reduit;
        if (reduit) {
          remiseAffichee.querySelector('[data-q4-remise-plein]').textContent = euros.format(plein / 100);
          remiseAffichee.querySelector('[data-q4-remise-pourcent]').textContent = pourcentDe(plein, total);
        }
      }
      if (pleinBarreFixe) {
        pleinBarreFixe.hidden = !reduit;
        if (reduit) pleinBarreFixe.textContent = euros.format(plein / 100);
      }
      if (lancement) lancement.hidden = lancementFini || taille !== lancement.dataset.taille;
      // Cartes 1 bâche / 2 bâches : prix du modèle choisi (Premium 54,95 €, Standard 39,99 €), économie en badge
      if (offreQuantite && Number.isFinite(centimes)) {
        // v17c : la carte « 2 bâches » est facultative, chaque élément absent est ignoré
        const ecrire = (selecteur, texte) => {
          offreQuantite.querySelectorAll(selecteur).forEach((element) => {
            element.textContent = texte;
          });
        };
        const masquer = (selecteur, cache) => {
          offreQuantite.querySelectorAll(selecteur).forEach((element) => {
            element.hidden = cache;
          });
        };
        const prixDeux = totalPour(centimes, 2, duo);
        const economie = centimes * 2 - prixDeux;
        ecrire('[data-q4-quantite-prix-1]', euros.format(centimes / 100));
        ecrire('[data-q4-quantite-prix-2]', euros.format(prixDeux / 100));
        ecrire('[data-q4-quantite-plein-2]', euros.format((centimes * 2) / 100));
        ecrire('[data-q4-quantite-economie]', euros.format(economie / 100));
        masquer('[data-q4-quantite-barre-2], [data-q4-quantite-badge], [data-q4-quantite-pourcent]', economie <= 0);
        if (economie > 0) ecrire('[data-q4-quantite-pourcent]', pourcentDe(centimes * 2, prixDeux));
        // Carte « 3 bâches » : 2 au prix unitaire du modèle choisi ; la bâche offerte vaut le prix unitaire
        if (troisActif) {
          const prixTrois = totalPour(centimes, 3, duo);
          ecrire('[data-q4-quantite-prix-3]', euros.format(prixTrois / 100));
          ecrire('[data-q4-quantite-plein-3]', euros.format((centimes * 3) / 100));
          ecrire('[data-q4-quantite-pourcent-3]', pourcentDe(centimes * 3, prixTrois));
          ecrire('[data-q4-quantite-valeur-3]', euros.format(centimes / 100));
          ecrire('[data-q4-quantite-economie-3]', euros.format((centimes * 3 - prixTrois) / 100));
        }
      }
      // Barre fixe : le nom du pack, ou celui du modèle quand il n'y a pas de pack à choisir
      const modele = racine.querySelector('[data-q4-tailles] input:checked + label .q4-modele-choix__nom');
      const sansPack = !blocOffres || blocOffres.hidden;
      if (nomBarre) {
        const nom = sansPack && modele ? modele.textContent : choisie.getAttribute('data-nom');
        nomBarre.textContent = nombre > 1 ? nom + ' × ' + nombre : nom;
      }
    };

    // Applique le modèle choisi à chaque offre : variante envoyée, prix, valeur, disponibilité.
    // Un pack qui n'existe pas pour ce modèle est masqué (jamais affiché comme épuisé).
    const appliquerTaille = () => {
      offres.forEach((radio) => {
        const absent = lire(radio, 'absent') === 'true';
        radio.closest('.q4-offre').hidden = absent;
        radio.value = lire(radio, 'id');
        radio.disabled = absent || lire(radio, 'dispo') !== 'true';
        const carte = radio.nextElementSibling;
        carte.querySelector('[data-q4-prix-carte]').textContent = lire(radio, 'prix');
        const prixBarre = lire(radio, 'barre');
        carte.querySelector('[data-q4-barre]').textContent = prixBarre;
        carte.querySelector('[data-q4-barre-bloc]').hidden = !prixBarre;
        const unitaire = lire(radio, 'unitaire');
        carte.querySelector('[data-q4-unitaire]').textContent = unitaire;
        carte.querySelector('[data-q4-economie]').textContent = lire(radio, 'economie');
        carte.querySelector('[data-q4-valeur]').hidden = !unitaire;
      });
      if (!offres.some((radio) => radio.checked && !radio.disabled)) {
        const premiere = offres.find((radio) => !radio.disabled);
        if (premiere) premiere.checked = true;
      }
      // Une seule offre possible (Standard) : pas de choix de pack à montrer
      if (blocOffres) blocOffres.hidden = offres.filter((radio) => !radio.closest('.q4-offre').hidden).length < 2;
      mettreAJourPrix();
    };

    // Galerie : amène la photo du modèle choisi, sans déplacer la page.
    const liste = racine.querySelector('.q4-galerie__liste');

    // Galerie collante sur ordinateur (v14) : collée sous l'en-tête si elle tient dans la fenêtre ; plus haute
    // (8 photos, deux lignes de vignettes, écran bas), elle défile jusqu'à montrer son bas, puis reste collée par
    // le bas : jamais de partie cachée, ni de colonne vide sous elle pendant que les options défilent.
    const galerie = racine.querySelector('.q4-galerie');
    if (galerie && 'ResizeObserver' in window) {
      const ajusterGalerie = () => {
        const entete = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const haut = Math.min(entete + 20, window.innerHeight - galerie.offsetHeight - 20);
        galerie.style.setProperty('--q4-galerie-haut', Math.round(haut) + 'px');
      };
      new ResizeObserver(ajusterGalerie).observe(galerie);
      window.addEventListener('resize', ajusterGalerie, { passive: true });
    }
    // Position de défilement d'une photo, mesurée à l'écran : offsetLeft dépend du défilement en cours et
    // de l'ancêtre positionné (galerie collante), il décalait la photo après un premier défilement (v10).
    const positionDe = (cible) =>
      liste.scrollLeft + cible.getBoundingClientRect().left - liste.getBoundingClientRect().left;
    const montrerMedia = (idMedia) => {
      if (!liste || !idMedia) return;
      const cible = liste.querySelector('[id$="-' + idMedia + '"]');
      if (cible) liste.scrollTo({ left: positionDe(cible), behavior: 'smooth' });
    };

    racine.addEventListener('change', (evenement) => {
      const cible = evenement.target;
      if (cible.matches('[data-q4-tailles] input')) {
        taille = cible.value;
        appliquerTaille();
        montrerMedia(cible.dataset.media);
      } else if (cible.matches('[data-q4-quantites] input')) {
        if (champQuantite) champQuantite.value = cible.value;
        mettreAJourPrix();
      } else if (cible.matches('.q4-form .q4-offre__radio') || cible === champQuantite) {
        if (cible === champQuantite) champQuantite.value = String(quantite());
        mettreAJourPrix();
      }
    });

    // Quantité : boutons − et +, de 1 à 10
    racine.querySelectorAll('[data-q4-moins], [data-q4-plus]').forEach((bouton) => {
      bouton.addEventListener('click', () => {
        if (!champQuantite) return;
        const pas = bouton.hasAttribute('data-q4-plus') ? 1 : -1;
        champQuantite.value = String(Math.min(10, Math.max(1, quantite() + pas)));
        mettreAJourPrix();
      });
    });

    // Modèle demandé par l'URL, sinon celui réellement coché : au retour arrière, le navigateur
    // peut restaurer l'état du formulaire alors que le HTML est rendu pour le modèle par défaut.
    const modeleDemande = parametres.get('modele');
    const radioModele = modeleDemande && racine.querySelector('[data-q4-tailles] input[value="' + modeleDemande + '"]');
    if (radioModele) radioModele.checked = true;
    const tailleCochee = racine.querySelector('[data-q4-tailles] input:checked');
    if (tailleCochee) taille = tailleCochee.value;
    // Quantité : demandée par l'URL (?quantite=2), sinon celle restaurée par le navigateur
    const quantiteDemandee = parametres.get('quantite');
    const radioQuantite =
      (quantiteDemandee && racine.querySelector('[data-q4-quantites] input[value="' + quantiteDemandee + '"]')) ||
      racine.querySelector('[data-q4-quantites] input:checked');
    if (radioQuantite) {
      radioQuantite.checked = true;
      if (champQuantite) champQuantite.value = radioQuantite.value;
    }
    appliquerTaille();
    if (radioModele) montrerMedia(radioModele.dataset.media);

    // Pack demandé par l'URL
    const packDemande = parametres.get('pack');
    if (packDemande) {
      const radio = offres.find((r) => r.dataset.pack === packDemande && !r.disabled);
      if (radio) {
        radio.checked = true;
        mettreAJourPrix();
      }
    }

    // Galerie : les vignettes font défiler la liste sans déplacer la page, la vignette active est signalée.
    const vignettes = [...racine.querySelectorAll('.q4-galerie__vignettes a')];
    const bandeVignettes = racine.querySelector('.q4-galerie__vignettes');
    const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // v17d : la vignette de la photo affichée reste visible dans la bande (quatre vignettes à la fois)
    const montrerVignette = (index) => {
      const element = vignettes[index] && vignettes[index].parentElement;
      if (!bandeVignettes || !element) return;
      const gauche = element.offsetLeft;
      const droite = gauche + element.offsetWidth;
      let cible = null;
      if (gauche < bandeVignettes.scrollLeft) cible = gauche;
      else if (droite > bandeVignettes.scrollLeft + bandeVignettes.clientWidth) cible = droite - bandeVignettes.clientWidth;
      if (cible !== null) bandeVignettes.scrollTo({ left: cible, behavior: mouvementReduit ? 'auto' : 'smooth' });
    };
    // v17d : flèches d'une bande défilante (la photo : une à la fois ; les vignettes : quatre à la fois), affichées
    // seulement s'il y a de quoi défiler, désactivées en bout de bande
    const brancherFleches = (bande, precedent, suivant) => {
      if (!bande || !precedent || !suivant) return;
      let attente = false;
      const mettreAJour = () => {
        attente = false;
        const fin = bande.scrollWidth - bande.clientWidth;
        precedent.hidden = suivant.hidden = fin <= 1;
        precedent.disabled = bande.scrollLeft <= 1;
        suivant.disabled = bande.scrollLeft >= fin - 1;
      };
      const defiler = (sens) => {
        const ecart = parseFloat(getComputedStyle(bande).columnGap) || 0;
        bande.scrollBy({ left: sens * (bande.clientWidth + ecart), behavior: mouvementReduit ? 'auto' : 'smooth' });
      };
      precedent.addEventListener('click', () => defiler(-1));
      suivant.addEventListener('click', () => defiler(1));
      bande.addEventListener(
        'scroll',
        () => {
          if (attente) return;
          attente = true;
          requestAnimationFrame(mettreAJour);
        },
        { passive: true }
      );
      if ('ResizeObserver' in window) new ResizeObserver(mettreAJour).observe(bande);
      mettreAJour();
    };
    brancherFleches(liste, racine.querySelector('[data-q4-galerie-prec]'), racine.querySelector('[data-q4-galerie-suiv]'));
    brancherFleches(
      bandeVignettes,
      racine.querySelector('[data-q4-vignettes-prec]'),
      racine.querySelector('[data-q4-vignettes-suiv]')
    );
    // v17e : carrousel d'avis, un avis à la fois ; les points suivent le défilement et y mènent. Sans script, la bande
    // défile au doigt ou au clavier et les points restent masqués.
    const listeAvis = racine.querySelector('[data-q4-temoignages-liste]');
    const pointsAvis = racine.querySelector('[data-q4-temoignages-points]');
    if (listeAvis && pointsAvis) {
      const avis = [...listeAvis.children];
      const points = [...pointsAvis.querySelectorAll('[data-q4-temoignage]')];
      let attenteAvis = false;
      const marquerPoint = () => {
        attenteAvis = false;
        const pas = avis.length > 1 ? avis[1].offsetLeft - avis[0].offsetLeft : listeAvis.clientWidth;
        const index = Math.min(avis.length - 1, Math.max(0, Math.round(listeAvis.scrollLeft / (pas || 1))));
        points.forEach((point, i) => {
          if (i === index) point.setAttribute('aria-current', 'true');
          else point.removeAttribute('aria-current');
        });
      };
      points.forEach((point, i) => {
        point.addEventListener('click', () => {
          if (!avis[i]) return;
          listeAvis.scrollTo({
            left: avis[i].offsetLeft - avis[0].offsetLeft,
            behavior: mouvementReduit ? 'auto' : 'smooth',
          });
        });
      });
      listeAvis.addEventListener(
        'scroll',
        () => {
          if (attenteAvis) return;
          attenteAvis = true;
          requestAnimationFrame(marquerPoint);
        },
        { passive: true }
      );
      pointsAvis.hidden = false;
      marquerPoint();
    }
    // v17e : date de l'avis en clair, à partir de la date saisie (attribut datetime) ; la date complète en info-bulle
    const dateAvis = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    const dateRelative = 'RelativeTimeFormat' in Intl ? new Intl.RelativeTimeFormat('fr', { numeric: 'auto' }) : null;
    const semainesRelatives = 'RelativeTimeFormat' in Intl ? new Intl.RelativeTimeFormat('fr', { numeric: 'always' }) : null;
    racine.querySelectorAll('[data-q4-date-avis]').forEach((element) => {
      const morceaux = (element.getAttribute('datetime') || '').split('-').map(Number);
      if (morceaux.length !== 3 || morceaux.some(Number.isNaN)) return;
      const jour = new Date(morceaux[0], morceaux[1] - 1, morceaux[2]);
      const aujourdHui = new Date();
      aujourdHui.setHours(0, 0, 0, 0);
      const ecart = Math.round((aujourdHui - jour) / 86400000);
      element.title = dateAvis.format(jour);
      // « aujourd'hui », « hier », « il y a 9 jours », puis « il y a 2 semaines » jusqu'à un mois, ensuite la date
      if (dateRelative && ecart >= 0 && ecart < 14) element.textContent = dateRelative.format(-ecart, 'day');
      else if (semainesRelatives && ecart >= 14 && ecart < 30) element.textContent = semainesRelatives.format(-Math.floor(ecart / 7), 'week');
      else element.textContent = dateAvis.format(jour);
    });
    if (liste && vignettes.length) {
      let indexMarque = -1;
      const marquer = (index) => {
        vignettes.forEach((lien, i) => {
          if (i === index) lien.setAttribute('aria-current', 'true');
          else lien.removeAttribute('aria-current');
        });
        if (index !== indexMarque) {
          indexMarque = index;
          montrerVignette(index);
        }
      };
      vignettes.forEach((lien, index) => {
        lien.addEventListener('click', (evenement) => {
          const cible = liste.querySelector(lien.getAttribute('href'));
          if (!cible) return;
          evenement.preventDefault();
          liste.scrollTo({ left: positionDe(cible), behavior: 'smooth' });
          marquer(index);
        });
      });
      let attenteGalerie = false;
      liste.addEventListener(
        'scroll',
        () => {
          if (attenteGalerie) return;
          attenteGalerie = true;
          requestAnimationFrame(() => {
            attenteGalerie = false;
            marquer(Math.round(liste.scrollLeft / Math.max(1, liste.clientWidth)));
          });
        },
        { passive: true }
      );
      marquer(0);
    }

    // Zoom : la photo en grand dans une boîte de dialogue native (Échap, focus rendu au déclencheur).
    const zoom = racine.querySelector('[data-q4-zoom]');
    if (zoom) {
      const imageZoom = zoom.querySelector('img');
      racine.querySelectorAll('[data-q4-zoom-src]').forEach((declencheur) => {
        declencheur.addEventListener('click', () => {
          imageZoom.src = declencheur.dataset.q4ZoomSrc;
          imageZoom.alt = declencheur.dataset.q4ZoomAlt || '';
          zoom.showModal();
        });
      });
      zoom.addEventListener('click', (evenement) => {
        if (evenement.target === zoom || evenement.target.closest('[data-q4-zoom-fermer]')) zoom.close();
      });
    }

    const formulaire = racine.querySelector('.q4-form');
    const bouton = racine.querySelector('.q4-achat .q4-bouton');
    const messageErreur = racine.querySelector('[data-q4-erreur-panier]');

    // Ajout au panier sans quitter la page quand le thème hôte a un panier latéral (Horizon) :
    // même événement standard Shopify que le formulaire produit d'Horizon (le panier latéral et le
    // compteur de l'en-tête se mettent à jour d'eux-mêmes), puis confirmation « Ajouté au panier »
    // (ou, à défaut, ouverture du panier latéral).
    // Si quoi que ce soit manque avant l'envoi, repli sur l'envoi classique du formulaire (page /cart).
    const tiroir = document.querySelector('cart-drawer-component');
    let ajoutEnCours = false;

    // Confirmation « Ajouté au panier » (format Nike) : photo, modèle, prix ajouté, nombre d'articles.
    // Renvoie false si le navigateur ne gère pas les popovers : le panier latéral s'ouvre alors.
    const confirmation = racine.querySelector('[data-q4-ajoute]');
    const montrerConfirmation = (ligne, panier, quantite) => {
      if (!confirmation || typeof confirmation.showPopover !== 'function') return false;
      const image = confirmation.querySelector('[data-q4-ajoute-image]');
      if (ligne.image) {
        const adresse = new URL(ligne.image, window.location.origin);
        adresse.searchParams.set('width', '192');
        image.src = adresse.href;
        image.hidden = false;
      } else {
        image.hidden = true;
      }
      confirmation.querySelector('[data-q4-ajoute-nom]').textContent = ligne.product_title || '';
      // Prix du modèle dans le panier, réductions automatiques comprises. La réduction « Pack 2 bâches » scinde la
      // paire en deux lignes (34,95 € et 20,00 €) : on additionne toutes les lignes de la variante (54,95 €).
      // Si le modèle était déjà au panier, la quantité totale est indiquée.
      const lignesDuModele = (panier.items || []).filter((article) => article.variant_id === ligne.variant_id);
      const lignes = lignesDuModele.length ? lignesDuModele : [ligne];
      const nombreDansLigne = lignes.reduce((somme, article) => somme + (Number(article.quantity) || 0), 0) || quantite;
      const totalLigne = lignes.reduce(
        (somme, article) =>
          somme + Number(article.final_line_price ?? (article.final_price ?? article.price) * article.quantity),
        0
      );
      confirmation.querySelector('[data-q4-ajoute-variante]').textContent =
        (ligne.variant_title || '') + (nombreDansLigne > 1 ? ' · Quantité ' + nombreDansLigne : '');
      confirmation.querySelector('[data-q4-ajoute-prix]').textContent = Number.isFinite(totalLigne)
        ? euros.format(totalLigne / 100)
        : '';
      confirmation.querySelector('[data-q4-ajoute-compte]').textContent = String(panier.item_count);
      if (confirmation.matches(':popover-open')) confirmation.hidePopover();
      confirmation.showPopover();
      // Le focus va sur le titre : il est annoncé, et Tab mène aux deux boutons
      confirmation.querySelector('.q4-ajoute__titre').focus({ preventScroll: true });
      return true;
    };

    // Fermeture (Échap, croix, clic à côté) : le focus revient au bouton d'achat s'il était dans le panneau
    if (confirmation) {
      confirmation.addEventListener('toggle', (evenement) => {
        if (evenement.newState !== 'closed' || !bouton) return;
        const actif = document.activeElement;
        if (!actif || actif === document.body || confirmation.contains(actif)) bouton.focus({ preventScroll: true });
      });
    }

    const ajouterSansRecharger = async () => {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const donnees = new FormData(formulaire);
      const sections = [...document.querySelectorAll('cart-items-component')]
        .map((composant) => composant.dataset.sectionId)
        .filter(Boolean);
      if (sections.length) donnees.append('sections', sections.join(','));
      const quantiteAjoutee = Number(donnees.get('quantity')) || 1;
      const racineRoutes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const differe = CartLinesUpdateEvent.createPromise();
      formulaire.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(donnees.get('id')), quantity: quantiteAjoutee }],
          promise: differe.promise,
        })
      );

      // À partir d'ici la requête est partie : plus de repli (il doublerait l'ajout)
      try {
        const reponse = await fetch(racineRoutes + 'cart/add.js', {
          method: 'POST',
          body: donnees,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        });
        const resultat = await reponse.json();
        const erreur = !reponse.ok || Boolean(resultat.status);
        const panier = await fetch(racineRoutes + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        differe.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
          detail: {
            items: panier.items,
            itemCount: quantiteAjoutee,
            source: 'q4-produit',
            sections: erreur ? undefined : resultat.sections,
            didError: erreur,
          },
        });
        if (erreur) {
          if (messageErreur) {
            messageErreur.textContent = resultat.description || resultat.message || messageErreur.dataset.texteDefaut;
            messageErreur.hidden = false;
          }
          return;
        }
        if (messageErreur) messageErreur.hidden = true;
        if (montrerConfirmation(resultat, panier, quantiteAjoutee)) return;
        const panneau = tiroir.closest('theme-drawer');
        if (panneau && typeof panneau.open === 'function' && !panneau.isOpen) panneau.open();
      } catch (erreurReseau) {
        differe.reject(erreurReseau);
        if (messageErreur) {
          messageErreur.textContent = messageErreur.dataset.texteDefaut;
          messageErreur.hidden = false;
        }
      }
    };

    if (formulaire && bouton) {
      formulaire.addEventListener('submit', (evenement) => {
        if (!tiroir || !window.fetch) {
          bouton.setAttribute('aria-busy', 'true');
          return; // envoi classique vers la page panier
        }
        evenement.preventDefault();
        if (ajoutEnCours) return; // double clic : un seul ajout
        ajoutEnCours = true;
        bouton.setAttribute('aria-busy', 'true');
        ajouterSansRecharger()
          .catch(() => formulaire.submit()) // module d'événements indisponible : envoi classique
          .finally(() => {
            ajoutEnCours = false;
            bouton.removeAttribute('aria-busy');
          });
      });
    }

    // Date de livraison estimée : jours ouvrés (lundi à vendredi) ajoutés à aujourd'hui, date du visiteur.
    // v16 : les jours fériés français ne comptent pas (11/11, 25/12, 1/1 tombent en semaine cet hiver), et la date
    // est recalculée quand la page revient à l'écran (onglet laissé ouvert la veille, retour arrière du navigateur).
    const estimation = racine.querySelector('[data-q4-estimation]');
    if (estimation) {
      // Dimanche de Pâques, calendrier grégorien (algorithme de Meeus, Jones et Butcher)
      const paques = (annee) => {
        const a = annee % 19;
        const b = Math.floor(annee / 100);
        const c = annee % 100;
        const h = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30;
        const l = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - h - (c % 4)) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const n = h + l - 7 * m + 114;
        return new Date(annee, Math.floor(n / 31) - 1, (n % 31) + 1);
      };
      const cleJour = (date) => date.getMonth() + 1 + '-' + date.getDate();
      const feries = {};
      const estFerie = (date) => {
        const annee = date.getFullYear();
        if (!feries[annee]) {
          const p = paques(annee);
          const apresPaques = (jours) => cleJour(new Date(annee, p.getMonth(), p.getDate() + jours));
          // 1er janvier, 1er et 8 mai, 14 juillet, 15 août, 1er et 11 novembre, 25 décembre,
          // lundi de Pâques, Ascension, lundi de Pentecôte
          feries[annee] = new Set(['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25',
            apresPaques(1), apresPaques(39), apresPaques(50)]);
        }
        return feries[annee].has(cleJour(date));
      };
      const ajouterJoursOuvres = (jours) => {
        const date = new Date();
        let restants = Number(jours) || 0;
        while (restants > 0) {
          date.setDate(date.getDate() + 1);
          const jour = date.getDay();
          if (jour !== 0 && jour !== 6 && !estFerie(date)) restants -= 1;
        }
        return date;
      };
      const format = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      const modele = estimation.dataset.modele || '';
      const texte = estimation.querySelector('[data-q4-estimation-texte]');
      // v17d : frise « Commandé (18 octobre), Expédié, Livré (23–30 octobre) »
      const formatJour = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
      const jourFrise = estimation.querySelector('[data-q4-frise-jour]');
      const livraisonFrise = estimation.querySelector('[data-q4-frise-livraison]');
      const intervalle = (debut, fin) =>
        typeof formatJour.formatRange === 'function'
          ? formatJour.formatRange(debut, fin)
          : formatJour.format(debut) + ' – ' + formatJour.format(fin);
      let jourCalcule = '';
      const majEstimation = () => {
        const aujourdhui = new Date().toDateString();
        if (aujourdhui === jourCalcule) return;
        jourCalcule = aujourdhui;
        const dateDebut = ajouterJoursOuvres(estimation.dataset.min);
        const dateFin = ajouterJoursOuvres(estimation.dataset.max);
        if (jourFrise) jourFrise.textContent = formatJour.format(new Date());
        if (livraisonFrise) livraisonFrise.textContent = intervalle(dateDebut, dateFin);
        if (!modele || !texte) return;
        const debut = format.format(dateDebut);
        const fin = format.format(dateFin);
        const morceaux = modele.split(/(\[DEBUT\]|\[FIN\])/).filter(Boolean).map((morceau) => {
          if (morceau !== '[DEBUT]' && morceau !== '[FIN]') return document.createTextNode(morceau);
          const fort = document.createElement('strong');
          fort.textContent = morceau === '[DEBUT]' ? debut : fin;
          return fort;
        });
        texte.replaceChildren(...morceaux);
      };
      majEstimation();
      window.addEventListener('pageshow', majEstimation);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') majEstimation();
      });
    }

    // Barre fixe : visible quand le bouton principal est passé au-dessus de l'écran (v16 ; jusqu'en v15, aussi tant
    // qu'il était encore plus bas, dès l'arrivée sur mobile).
    // Un écouteur de défilement (une mesure par image) plutôt qu'un IntersectionObserver :
    // ce dernier ne se déclenche pas quand un défilement rapide saute le bouton d'un coup.
    // v15 : elle s'efface aussi quand le bandeau d'appel de fin de page ou le pied de page entre à l'écran ; sinon
    // elle recouvre le bouton « Obtenir la mienne » du bandeau. Écouteur en phase de capture : dans l'aperçu
    // Shopify, la page défile dans un conteneur et non dans la fenêtre.
    const barre = racine.querySelector('.q4-barre-fixe');
    if (bouton && barre) {
      const boutonBarre = barre.querySelector('button');
      const finDePage = document.querySelectorAll('.q4-bandeau, .q4-pied');
      const aLEcran = (element) => {
        const cadre = element.getBoundingClientRect();
        return cadre.top < window.innerHeight && cadre.bottom > 0;
      };
      // v16 : visible seulement une fois le bouton principal dépassé (remonté au-dessus de l'écran), plus à l'arrivée
      // sur la page quand le bouton est encore plus bas : demande de Qusai, la barre ne double plus un bouton à venir.
      const mettreAJourBarre = () => {
        const cadre = bouton.getBoundingClientRect();
        const visible = cadre.bottom < 0 && !Array.prototype.some.call(finDePage, aLEcran);
        if (visible === barre.classList.contains('est-visible')) return;
        barre.classList.toggle('est-visible', visible);
        barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
        boutonBarre.tabIndex = visible ? 0 : -1;
      };
      let enAttente = false;
      document.addEventListener(
        'scroll',
        () => {
          if (enAttente) return;
          enAttente = true;
          requestAnimationFrame(() => {
            enAttente = false;
            mettreAJourBarre();
          });
        },
        { passive: true, capture: true }
      );
      window.addEventListener('resize', mettreAJourBarre, { passive: true });
      mettreAJourBarre();
    }
  };

  const toutInitialiser = (contexte) => contexte.querySelectorAll('.q4-produit').forEach(initialiser);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => toutInitialiser(document));
  } else {
    toutInitialiser(document);
  }
  document.addEventListener('shopify:section:load', (evenement) => toutInitialiser(evenement.target));
})();
